<template>
    <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#e8eff9',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
            label="ID"
            align="center"
            header-align="center"
            prop="id"
        >
        </el-table-column>
        <el-table-column
            label="直播课程名称"
            prop="video_title"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="cursor: pointer">
                    {{ scope.row.video_title }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="课程封面"
            prop="cover_img"
            align="center"
            header-align="center"
            width="100"
        >
            <template slot-scope="scope">
                <img
                    :src="picUrl(scope.row.cover_img)"
                    alt=""
                    style="width: 100%"
                />
            </template>
        </el-table-column>
        <el-table-column
            label="市场价"
            prop="v_price"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="销售价"
            prop="t_price"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="建课学校"
            prop="school_title"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="建课讲师"
            prop="t_name"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="学习人次"
            prop="video_order_count"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="报名方式"
            prop="apply_type"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                {{ applyType(scope.row.apply_type) }}
            </template>
        </el-table-column>
        <el-table-column
            label="是否公开报名"
            prop="is_overt"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div
                    :style="{
                        color: scope.row.is_overt === '1' ? 'black' : 'red',
                    }"
                >
                    {{ scope.row.is_overt === "1" ? "是" : "否" }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            prop="studyNum"
            align="center"
            header-align="center"
            min-width="200"
            class-name="operation"
        >
            <template slot-scope="scope">
                <div class="operation">
                    <span @click="linkToClassTime(scope.row)">课时管理</span>
                    <span @click="linkToEdit(scope.row)" v-show="!isPartner"
                        >编辑</span
                    >
                    <span
                        v-if="activeName === 'okAudit'"
                        v-show="!isPartner"
                        @click="
                            $router.push(
                                linkToJudge(
                                    `/index.php?app=live&mod=AdminLive&act=reviewLive&tabHash=reviewLive&id=${scope.row.id}`
                                )
                            )
                        "
                        >评价</span
                    >
                    <span
                        @click="DisablesClass(scope.row.id)"
                        v-show="!isPartner"
                        >{{ activeName === "delAudit" ? "启用" : "禁用" }}</span
                    >
                    <span
                        v-if="activeName === 'delAudit'"
                        v-show="!isPartner"
                        @click="DisablesClass(scope.row.id)"
                        >彻底删除</span
                    >
                    <span v-if="activeName === 'waitAudit'">提交审核</span>
                    <span v-if="activeName === 'waitAudit'">审核通过</span>
                    <span v-if="activeName === 'waitAudit'">审核退回</span>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { DisablesClass, reOpenLine } from "@/api/LiveLesson/index.js";
export default {
    data() {
        return {
            isPartner: this.$route.query.isPartner,
            multipleSelection: [],
        };
    },
    methods: {
        // 跳转到课时管理
        linkToClassTime(item) {
            this.$emit("toClassTime", this.activeName, item, "classTime");
        },
        // 跳转到编辑
        linkToEdit(item) {
            this.$emit(
                "toEdit",
                // 课程信息
                item,
                // 跳转的表格
                "editAudit"
            );
        },
        // 评价
        linkToJudge(u) {
            let url = window.location.protocol + "//" + window.location.host;
            if (window.location.host == "localhost:5001") {
                url = "https://gz.hnjk.net/" + u;
            }
            if (window.location.host == "fxl.sce.scut.edu.cn") {
                url = url + "/zk" + u;
            }
            return url;
        },
        // 封面图片
        picUrl(u) {
            // let url = window.location.protocol + "//" + window.location.host;
            // if (window.location.host == "localhost:5001") {
            //     url = "http://gz.hnjk.net/" + u;
            // }
            // if (window.location.host == "localhost:5001") {
            //     url = "http://gz.hnjk.net/" + "/zk" + u;
            // }
            let url = "http://gz.hnjk.net/" + u;
            return url;
        },
        // 报名方式
        applyType(item) {
            switch (item) {
                case "1":
                    return "先审核后缴费";
                    break;
                case "2":
                    return "先缴费后审核";
                    break;
                case "3":
                    return "仅审核无缴费";
                    break;
                case "4":
                    return "无审核仅缴费";
                    break;
                case "5":
                    return "无审核无缴费";
                    break;
                default:
                    break;
            }
        },
        // 禁用请求
        async DisablesClass(ids) {
            if (this.activeName !== "delAudit") {
                this.$confirm("此操作将禁用该课程, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        DisablesClass({
                            ids,
                            status: 1,
                        });
                        this.$message({
                            type: "success",
                            message: "禁用成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消禁用",
                        });
                    });
            } else {
                this.$confirm("此操作将启用该课程, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        reOpenLine({
                            id: ids,
                        });
                        this.$message({
                            type: "success",
                            message: "启用成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消启用",
                        });
                    });
            }
        },

        // 多选按钮
        handleSelectionChange(val) {
            let res = val.map((item) => item.id);
            this.multipleSelection = res;
        },
    },
    props: {
        activeName: {
            type: String,
        },
        tableData: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
.operation {
    span {
        font-size: 14px;
        color: #6b9eff;
        border-right: 1px solid #6b9eff;
        padding: 5px;
        &:last-child {
            border-right: 0;
        }
    }
    color: #6b9eff;
}
</style>

